/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Quicktools_Spell_CheckInputs */



/**
* | output |
* | --- |
* | "Spell Check" |
*
* @param {Options_Quicktools_Spell_CheckInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_quicktools_spell_check = /** @type {((inputs?: Options_Quicktools_Spell_CheckInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Quicktools_Spell_CheckInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Vérification orthographique")
	if (locale === "de") return /** @type {LocalizedString} */ ("Rechtschreibprüfung")
	if (locale === "it") return /** @type {LocalizedString} */ ("Controllo ortografico")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Проверка орфографии")
	if (locale === "es") return /** @type {LocalizedString} */ ("Corrector ortográfico")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("拼写检查")
	if (locale === "ja") return /** @type {LocalizedString} */ ("スペルチェック")
	if (locale === "hi") return /** @type {LocalizedString} */ ("वर्तनी की जाँच")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Correção ortográfica")
	return /** @type {LocalizedString} */ ("Spell Check")
});